import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { UiService, MicrofrontendsService } from 'core/services';

export const MicroFrontendResolver: ResolveFn<boolean> = async (
  route?: ActivatedRouteSnapshot,
  state?: RouterStateSnapshot,
  uiService: UiService = inject(UiService),
  microfrontendsService: MicrofrontendsService = inject(MicrofrontendsService)
): Promise<any> => {
  const { microfrontends } = route.data;

  uiService.displayPreloader();
  await Promise.all(microfrontends.map((micro) => microfrontendsService.hasMicrofrontend(micro)));
  uiService.hidePreloader();

  return Promise.resolve(true);
};
